import { ResponseErrorAlert } from "@nimble/react-requests/components/shared/response-error-alert";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function ResponseErrorDialog({
  error,
  onClose,
}: {
  error: Error;
  onClose: () => void;
}) {
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Something went wrong</DialogTitle>
        </DialogHeader>
        <ResponseErrorAlert error={error} />
      </DialogContent>
    </Dialog>
  );
}
